import { FormattedMessageWithTooltipHeaderRenderer } from '../../../components/HeaderRenderers';
import { gridNumberFormatter, formattedNumberValueGetter } from '../../../components/ValueFormatters';
import { normalizeColumnDefs } from '../../../utils';
import { leftPinnedColumn, numericColumn } from '../../columns';
import * as FIELDS from '../../fields';
import { COUNTRY_REALTIME_REPORT_ID } from './countryRealtimeReportId';

const countryReportColumnDefinition = [
    {
        headerName: FIELDS.COUNTRY_CODE.label,
        field: FIELDS.COUNTRY_CODE.field,
        type: [leftPinnedColumn],
        cellRenderer: FIELDS.COUNTRY_CODE.cellRenderer,
        cellRendererParams: FIELDS.COUNTRY_CODE.renderParams,
        csvValueGetter: FIELDS.COUNTRY_CODE.csvValueGetter,
    },
    ...[
        FIELDS.SPENT,
        FIELDS.VCTR,
        FIELDS.VISIBLE_IMPRESSIONS,
        FIELDS.CLICKS,
        FIELDS.AVERAGE_CPC,
        FIELDS.CVR,
        FIELDS.CVR_CLICKS,
        FIELDS.CVR_VIEWS,
        FIELDS.CONVERSIONS,
        FIELDS.CONVERSIONS_CLICKS,
        FIELDS.CONVERSIONS_VIEWS,
        FIELDS.CPA,
        FIELDS.CPA_CLICKS,
        FIELDS.CPA_VIEWS,
        FIELDS.VCPM,
        FIELDS.IMPRESSIONS,
        FIELDS.CONVERSIONS_VALUE,
        FIELDS.ROAS,
    ].map(fieldConfig => ({
        headerName: fieldConfig.label,
        headerValueGetter: fieldConfig.headerValueGetter || FormattedMessageWithTooltipHeaderRenderer,
        headerComponentParams: fieldConfig.headerComponentParams,
        field: fieldConfig.field,
        type: [numericColumn],
        valueFormatter: gridNumberFormatter,
        cellRendererParams: fieldConfig.renderParams,
        csvValueGetter: fieldConfig.csvValueGetter || formattedNumberValueGetter,
        referenceColId: fieldConfig.referenceColId,
        permissions: fieldConfig.permissions,
        visibilityCondition: fieldConfig.visibilityCondition,
    })),
];

export const normalizedCountryReportColumnDefinition = normalizeColumnDefs(
    countryReportColumnDefinition,
    COUNTRY_REALTIME_REPORT_ID
);
